module.exports = __webpack_public_path__ + "static/media/11.cdbe2767.jpg";